export const SEOTitleTemplate = ({ title }: { title: string }) => {
  return title + " | GotTheTest Employer "
}
